import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavSectionEnum } from '../nav-section.enum';
import { PageInfoService } from '../page-info.service';
import { GrantService } from '../../authentication/grant.service';
import { Grant } from '../../authentication/grant';
import { PermissionEnum } from '../../authentication/permission-enum';

/**
 * This component is used for section navigation in the application.
 */
@Component({
	selector: 'cc-page-navbar',
	templateUrl: './page-navbar.component.html',
	styleUrls: ['./page-navbar.component.css']
})
export class PageNavbarComponent implements OnInit, OnDestroy {

// #region [ Fields ]

	/** Stores the current navigation section. */
	private _CurrentSection: NavSectionEnum;

	/** Subscription for the page info service. */
	private _PageInfoSubscription: Subscription;

// #region [ Constructor ]

	constructor(
		private _PageInfoService: PageInfoService,
		private _GrantService: GrantService
	) { }

// #region [ Properties ]

	/**
	 * Indicates if the quoting navbar item should be displayed.
	 */
	public get ShowQuoting(): boolean {
		if (this._GrantService.AcceptedGrants != null && this._GrantService.AcceptedGrants.length > 0) {
			let objFilteredGrants: Grant[];
			objFilteredGrants = this._GrantService.AcceptedGrants.filter(objGrant => objGrant.Permission == PermissionEnum.QuoteShipments);
			return (objFilteredGrants.length > 0);
		}
		else
			return false;
	}

	/**
	 * Indicates if the tracking navbar item should be displayed.
	 */
	public get ShowTracking(): boolean {
		if (this._GrantService.AcceptedGrants != null && this._GrantService.AcceptedGrants.length > 0) {
			let objFilteredGrants: Grant[];
			objFilteredGrants = this._GrantService.AcceptedGrants.filter(objGrant => objGrant.Permission == PermissionEnum.TrackShipments);
			return (objFilteredGrants.length > 0);
		}
		else
			return false;
	}

// #region [ Event Handers ]

	/**
	 * Component initialization.
	 */
	public ngOnInit(): void {
		// Subscribe to the page info service and save the subscription for later.
		this._PageInfoSubscription = this._PageInfoService.GetPageInfoObserver().subscribe(objInfo => this._CurrentSection = objInfo.CurrentSection);

		this._GrantService.LoadAcceptedGrants();
	}

	/**
	 * Component destruction.
	 */
	public ngOnDestroy(): void {
		// Unsubscribe from any saved subscriptions.
		this._PageInfoSubscription.unsubscribe();
	}

// #region [ Public Methods ]

	/**
	 * Gets the class names to be used for navigation items.
	 *
	 * @param Page The navigation section querying it's CSS.
	 * @returns A JSON object with the CSS class names to use.
	 * @see ngClass
	 */
	public GetNavClassNames(Page: NavSectionEnum): object {
		return {
			"NavbarItem": true,
			"SelectedNavbarItem": (Page == this._CurrentSection)
		};
	}

}